import { createContext } from 'react';
import { HistoryContextType } from './types';

export const HistoryContext = createContext<HistoryContextType>(
  {} as unknown as HistoryContextType,
);
